<div class="container-fluid section pt-3 pb-2"
    [ngClass]="{'section-midwife': authService.user?.userType==userType.MIDWIFE, 'section-mum': authService.user?.userType==userType.MUM}">
    <div class="d-flex flex-column">
        <span class="edit mb-1" data-toggle="modal" data-target="#write-intro"
            *ngIf="!dashboard.intro && authService.user?.userType==userType.MIDWIFE">Edit</span>
        <span class="edit mb-1" [routerLink]="['/edit-profile-midwife']"
            *ngIf="dashboard.intro && authService.user?.userType==userType.MIDWIFE">Edit</span>
        <span class="edit mb-1" [routerLink]="['/edit-profile-mum']"
        *ngIf="!dashboard.intro && authService.user?.userType==userType.MUM">Edit</span>
        <img [src]="dashboard.profileImage" class="profile-img" alt="profile pic" *ngIf="dashboard.profileImage">
        <img class="profile-img" *ngIf="!dashboard.profileImage" alt="profile pic"
                        src="../../../../../../assets/Images/pro-pic.png">
        <span class="header mt-2">{{dashboard?.name}}
            <span class="ml-2 text-muted section-text"
                *ngIf="authService.user?.userType==userType.MUM">({{dashboard?.age}})</span></span>
        <div class="horizontal-line my-3"></div>
        <div class="d-flex flex-row mb-2">
            <i class="fas fa-phone icon phone"></i>
            <span class="section-text ml-3">{{dashboard.user[0]?.userPhonenumber}}</span>
        </div>
        <div class="d-flex flex-row my-2">
            <i class="fas fa-envelope icon"></i>
            <span class="section-text ml-3">{{dashboard.user[0]?.userEmail}}</span>
        </div>
        <div class="d-flex flex-row my-2">
            <i class="fas fa-map-marker-alt icon pl-1"></i>
            <span class="section-text ml-3">{{dashboard?.address}}</span>
        </div>
        <div class="horizontal-line my-2"></div>
        <div class="row excess-content" *ngIf="authService.user?.userType==userType.MIDWIFE">
            <div class="col-6 pr-0"><span class="sub-title">Specialized in</span></div>
            <div class="col-6 pl-0"><span class="sub-title-text">{{dashboard?.speciality}}</span></div>
        </div>
        <div class="row excess-content mt-1" *ngIf="authService.user?.userType==userType.MIDWIFE">
            <div class="col-6 pr-0"><span class="sub-title">Languages</span></div>
            <div class="col-6 pl-0"><span class="sub-title-text">{{dashboard?.languages}}</span></div>
        </div>
        <div class="row excess-content mt-1" *ngIf="authService.user?.userType==userType.MIDWIFE">
            <div class="col-6 pr-0"><span class="sub-title">Ethnicity</span></div>
            <div class="col-6 pl-0"><span class="sub-title-text">{{dashboard?.ethnicity}}</span></div>
        </div>
        <div class="row excess-content mt-1" *ngIf="authService.user?.userType==userType.MIDWIFE">
            <div class="col-6 pr-0"><span class="sub-title">Service areas</span></div>
            <div class="col-6 pl-0"><span class="sub-title-text">{{dashboard?.serviceAreas}}</span></div>
        </div>
        <span class="sub-title mt-2" *ngIf="authService.user?.userType==userType.MIDWIFE">About</span>
        <span class="section-text my-2" *ngIf="dashboard.intro && authService.user?.userType==userType.MIDWIFE">
            {{dashboard?.intro}}
        </span>
        <div class="no-intro-section text-center mt-2 py-3 px-1"
            *ngIf="!dashboard.intro && authService.user?.userType==userType.MIDWIFE">
            <span class="title">No info added!</span>
            <span class="sub-text mt-2">Click Edit button above to edit profile</span>
        </div>
        <div class="d-flex flex-row justify-content-center">
            <span class="section-text mr-1" *ngIf="authService.user?.userType==userType.MUM">Due on:</span>
            <span class="section-text" *ngIf="authService.user?.userType==userType.MUM">
                <strong>{{dashboard?.dueDate | date:'EEE dd MMM, yyyy'}}</strong></span>
        </div>
        <circle-progress class="text-center" *ngIf="authService.user?.userType==userType.MUM" [backgroundPadding]="-2"
            [percent]="progressPercent" [animation]="true" [outerStrokeGradient]='true' [title]="progressTitle"
            [backgroundPadding]="10" [showSubtitle]='false'></circle-progress>
    </div>
</div>

<!-- Write Intro Modal Begins -->
<app-write-intro [dashboard]="dashboard"></app-write-intro>
<!-- Write Intro Modal Ends -->
